
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120.028 20C64.764 20 20 64.752 20 120s44.764 100 100.028 100S220 175.192 220 120 175.236 20 120.028 20zm0 7.901c24.612 0 47.756 9.593 65.143 26.975 17.386 17.381 26.983 40.519 26.983 65.124 0 24.605-9.597 47.743-26.983 65.124-17.387 17.382-40.531 26.975-65.143 26.975-24.612 0-47.756-9.593-65.142-26.975C37.499 167.686 27.903 144.549 27.903 120c0-24.549 9.596-47.743 26.983-65.124 17.386-17.382 40.53-26.975 65.142-26.975zm7.734 157.392h-16.201V89.865h16.201v95.428zm0-112.923h-16.201V55.835h16.201V72.37z","fill-rule":"nonzero"}})])
          )
        }
      }
    